// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/font/css/fontello.css
// module id = 125
// module chunks = 0